// Import env first so a malformed VITE_* var crashes at boot with a clear
// Zod error rather than degrading silently inside Supabase / Sentry init.
import './env';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './services/supabase/AuthContext';
import { initErrorReporting } from './services/errorReporting';
import './index.css';

initErrorReporting();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root was not found in the document.');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
